import React, { createContext, useContext, useMemo } from 'react'
import { createClient, Client } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'

import { FormService } from '@/api/form/v1/form_pb'

type FormContextValue = {
	client: Client<typeof FormService>
}

const FormContext = createContext<FormContextValue | null>(null)

export function FormProvider(props: { baseUrl: string; children: React.ReactNode }) {
	const transport = useMemo(
		() =>
			createConnectTransport({
				baseUrl: props.baseUrl,
			}),
		[props.baseUrl],
	)

	const client = useMemo(() => createClient(FormService, transport), [transport])

	const value = useMemo(() => ({ client }), [client])

	return <FormContext.Provider value={value}>{props.children}</FormContext.Provider>
}

export function useForm() {
	const ctx = useContext(FormContext)
	if (!ctx) throw new Error('useForm must be used within <FormProvider>')
	return ctx
}
